import React from "react";
import { connect } from "react-redux";
import get from "lodash.get";

// HELPERS
import { AnalyticsHelper } from "../../helpers/analyticsHelper";

// ACTIONS
import { getPage } from "../shared/reducer";

// COMPONENTS
import { Loader } from "semantic-ui-react";
import DonatePageView from "./donatePageView";
import DonatePage from "./donatePage";

// CONSTANTS
import { loadingStatus } from "../../constants/loading";

class DonateWizardContainer extends React.Component {
  componentDidMount() {
    const { primaryPath, secondaryPath } = this.props.match.params;
    if (this.props.loading === loadingStatus.NOT_STARTED) {
      this.props.getPage(primaryPath, secondaryPath);
    }
  }

  componentDidUpdate() {
    if (this.props.loading === loadingStatus.SUCCESS) {
      const campaign = get(this.props, "campaign");
      AnalyticsHelper.initializeTrackers(campaign);
      if (campaign?.template?.value?.forceRedirectTo) {
        window.location.href = campaign?.template?.value?.forceRedirectTo;
      }
    }
  }

  isPageLoading = () => {
    return (
      this.props.loading === loadingStatus.NOT_STARTED ||
      this.props.loading === loadingStatus.IS_LOADING ||
      !!this.props.campaign?.template?.value?.forceRedirectTo
    );
  };

  render() {
    const isLoading = this.isPageLoading();

    return (
      <React.Fragment>
        {isLoading && <Loader active />}
        {!isLoading && (
          <DonatePage
            customText={this.props.customText}
            heroImageUrl={this.props.heroImageUrl}
            mainImageUrl={this.props.mainImageUrl}
          >
            <DonatePageView isRecurring={this.props.isRecurring} />
          </DonatePage>
        )}
      </React.Fragment>
    );
  }
}

const mapState = ({ page, donation }) => {
  return {
    campaign: get(page, "campaign"),
    loading: page.loadingStatus,
    customText: get(
      page.campaign,
      "template.value.customText.standaloneDonationForm"
    ),
    heroImageUrl: get(page.campaign, "heroImageUrl"),
    mainImageUrl: get(page.campaign, "mainImageUrl"),
    isRecurring: get(donation, "subscription.enabled"),
  };
};

const mapDispatch = (dispatch) => {
  return {
    getPage: (primaryPath, secondaryPath) => {
      dispatch(getPage(primaryPath, secondaryPath));
    },
  };
};

const DonateWizard = connect(mapState, mapDispatch)(DonateWizardContainer);
export default DonateWizard;
